import { validator } from "@/utils/validator";

export const masterDataMainOccupationSchema = validator.object().shape({
  mainOccupation: validator.string().emptyToNull().label("職種").required(),
  fmMainOccupationRenewVisaCsvCode: validator.string().emptyToNull().label("期間更新CSVのコード（列FM）").required(),
});
